import { api } from "./authService";

export interface MasterProgramItem {
  id: string;
  department: string;
  department_name?: string;
  department_code?: string;
  institution_type?: string;
  institution_type_name?: string;
  institution_type_code?: string;
  university?: string;
  university_name?: string;
  university_code?: string;
  name: string;
  short_name?: string;
  program_code: string;
  degree_level: "Certificate" | "Diploma" | "UG" | "PG" | "Doctorate";
  program_category:
    | "Engineering"
    | "Science"
    | "Commerce"
    | "Arts"
    | "Medical"
    | "Law"
    | "Management"
    | "Education"
    | "Pharmacy"
    | "Agriculture"
    | "Architecture"
    | "Design"
    | "Vocational";
  duration_years: number;
  total_semesters: number;
  total_credits?: number;
  academic_pattern: "Annual" | "Semester" | "Trimester" | "CBCS" | "NEP 2020";
  approval_body?: string;
  description?: string;
  is_active: boolean;
  display_order: number;
  created_at?: string;
  updated_at?: string;
}

export const programService = {
  getPrograms: async (params?: {
    search?: string;
    is_active?: boolean;
    status?: string;
    institution_type?: string;
    university?: string;
    department?: string;
    degree_level?: string;
    program_category?: string;
    academic_pattern?: string;
    approval_body?: string;
  }): Promise<{ results: MasterProgramItem[] } | MasterProgramItem[]> => {
    const response = await api.get("/master/programs/", { params });
    return response.data;
  },

  createProgram: async (data: {
    department: string;
    name: string;
    short_name?: string;
    program_code: string;
    degree_level: string;
    program_category?: string;
    duration_years?: number;
    total_semesters?: number;
    total_credits?: number;
    academic_pattern?: string;
    approval_body?: string;
    description?: string;
    institution_type?: string;
    university?: string;
    is_active?: boolean;
    display_order?: number;
  }): Promise<MasterProgramItem> => {
    const response = await api.post("/master/programs/", data);
    return response.data;
  },

  updateProgram: async (
    id: string,
    data: Partial<{
      department: string;
      name: string;
      short_name: string;
      program_code: string;
      degree_level: string;
      program_category: string;
      duration_years: number;
      total_semesters: number;
      total_credits: number;
      academic_pattern: string;
      approval_body: string;
      description: string;
      institution_type: string;
      university: string;
      is_active: boolean;
      display_order: number;
    }>
  ): Promise<MasterProgramItem> => {
    const response = await api.patch(`/master/programs/${id}/`, data);
    return response.data;
  },

  deleteProgram: async (id: string): Promise<void> => {
    await api.delete(`/master/programs/${id}/`);
  },
};
